export const CARE_SNAPSHOT_STEPS = {
  ABOUT: 1,
  DAILY_SUPPORT: 2,
  PATTERNS_RESPONSES: 3,
  GOALS_GROWTH: 4,
  HEALTH_CARE: 5,
  REVIEW: 6,
};

export const CARE_SNAPSHOT_SECTION_KEYS = {
  ABOUT: "about",
  DAILY_SUPPORT: "dailySupport",
  PATTERNS_RESPONSES: "patternsResponses",
  GOALS_GROWTH: "goalsGrowth",
  HEALTH_CARE: "healthCare",
};

export const CARE_SNAPSHOT_SECTIONS = [
  {
    key: CARE_SNAPSHOT_SECTION_KEYS.ABOUT,
    step: CARE_SNAPSHOT_STEPS.ABOUT,
    name: "About",
    description: "Required: name, date of birth, and care focus. Optional: photo, pronouns, language, care setting, and emergency contacts.",
  },
  {
    key: CARE_SNAPSHOT_SECTION_KEYS.DAILY_SUPPORT,
    step: CARE_SNAPSHOT_STEPS.DAILY_SUPPORT,
    name: "Daily Support",
    description: "What helps day-to-day routines and comfort.",
  },
  {
    key: CARE_SNAPSHOT_SECTION_KEYS.PATTERNS_RESPONSES,
    step: CARE_SNAPSHOT_STEPS.PATTERNS_RESPONSES,
    name: "Behavior",
    description: "Behavior, stress signs, and calming support.",
  },
  {
    key: CARE_SNAPSHOT_SECTION_KEYS.GOALS_GROWTH,
    step: CARE_SNAPSHOT_STEPS.GOALS_GROWTH,
    name: "Goals & Growth",
    description: "Current goals and support strategies.",
  },
  {
    key: CARE_SNAPSHOT_SECTION_KEYS.HEALTH_CARE,
    step: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
    name: "Medication",
    description: "Medication, allergy, and care information.",
  },
];

export const CARE_SNAPSHOT_EDIT_STEPS = {
  about: CARE_SNAPSHOT_STEPS.ABOUT,
  basics: CARE_SNAPSHOT_STEPS.ABOUT,
  dailySupport: CARE_SNAPSHOT_STEPS.DAILY_SUPPORT,
  whatHelps: CARE_SNAPSHOT_STEPS.DAILY_SUPPORT,
  communicationStyle: CARE_SNAPSHOT_STEPS.DAILY_SUPPORT,
  patternsResponses: CARE_SNAPSHOT_STEPS.PATTERNS_RESPONSES,
  whatCanBeDifficult: CARE_SNAPSHOT_STEPS.PATTERNS_RESPONSES,
  behavior: CARE_SNAPSHOT_STEPS.PATTERNS_RESPONSES,
  goalsGrowth: CARE_SNAPSHOT_STEPS.GOALS_GROWTH,
  currentGoals: CARE_SNAPSHOT_STEPS.GOALS_GROWTH,
  familySupportTips: CARE_SNAPSHOT_STEPS.GOALS_GROWTH,
  schoolTherapySuggestions: CARE_SNAPSHOT_STEPS.GOALS_GROWTH,
  support: CARE_SNAPSHOT_STEPS.GOALS_GROWTH,
  healthCare: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
  health: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
  careInfo: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
  medication: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
  medications: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
  meds: CARE_SNAPSHOT_STEPS.HEALTH_CARE,
};

export const getCareSnapshotEditStep = (sectionKey) => CARE_SNAPSHOT_EDIT_STEPS[sectionKey] ?? 0;
